module.exports = __webpack_public_path__ + "static/media/caret-left.12fb2729.svg";